import * as React from 'react';
import { Dialog } from '@mui/material';
import { Dispatch } from 'react';
import { useGetIcons } from '../../../hooks/useTalent';
import SelectIconModalTitle from './SelectIconModalTitle';
import SelectIconModalContent from './SelectIconModalContent';

type SelectIconModalProps = {
    onClose:() => void,
    isOpen: boolean,
    onImageSelect: (value: string) => void,
    inputValue: string,
    setInputValue: Dispatch<React.SetStateAction<string>>,
}

export default function SelectIconModal({
  onClose,
  isOpen,
  onImageSelect,
  inputValue,
  setInputValue,
}:SelectIconModalProps): JSX.Element {
  const { data } = useGetIcons() || {};
  const getFilteredData = () => data &&
   data.filter((item:{name:string, url: string}) => item.name.includes(inputValue.trim()));

  return (
    <Dialog open={ isOpen } onClose={ onClose }>
      <SelectIconModalTitle onClick={ onClose } />
      <SelectIconModalContent
        onClick={ onImageSelect }
        onInputChange={ setInputValue }
        value={ inputValue }
        data={ getFilteredData() }
      />
    </Dialog>
  );
}
